import React, { useEffect, useState } from 'react';
import { PrematchContext } from '../Prematch';
import { BreadcrumbContext } from './BreadcrumbContext';
import CategoryLink from './CategoryLink';

function CategoryBreadcrumb(props) {
    const prematchContext = React.useContext(PrematchContext);
    const breadcrumbContext = React.useContext(BreadcrumbContext);
    const [dropdownToggled, setDropdownToggled] = useState(false);

    function toggleDropdown() {
        if (dropdownToggled) {
            setDropdownToggled(false);
        } else {
            breadcrumbContext.setType('category');
        }
    }

    useEffect(() => {
        if (breadcrumbContext && breadcrumbContext.type) {
            if (breadcrumbContext.type === 'category' && !dropdownToggled) {
                setDropdownToggled(true);
            } else if (dropdownToggled) {
                setDropdownToggled(false);
            }
        }
    }, [breadcrumbContext]);

    let categories = prematchContext.applyTemporalFilter(props.categories);
    // If the tournament has been opened from the favorites section, only show favorite tournaments in the breadcrumb menu
    if (prematchContext.openedFromFavorites) {
        const favoriteCategories = new Set();
        Object.keys(prematchContext.favoriteTournaments).map(k => favoriteCategories.add(parseInt(k.split('_')[1]), 10));
        const filtered = [];
        categories.forEach(t => favoriteCategories.has(t.id) && filtered.push(t));
        if (filtered.length > 0) {
            categories = filtered;
        }
    }

    return (
        <span className="nav-breadcrumb" onClick={toggleDropdown}>
            <span className="nav-breadcrumb-label" >{props.desc}</span>
            {dropdownToggled &&
                <div className="nav-dropdown">
                    {categories.map(c => {
                        function handleClick() {
                            prematchContext.openCategory(c, false);
                        }
                        const selected = c.id === props.selected;
                        return (
                           /*  <div key={c.id} className={"event-desc text-small" + classIf(selected, 'selected')} onClick={handleClick}>
                                <span>{c.descrizione}</span>
                            </div> */
                            <CategoryLink key={c.id} {...c} selected={selected} onClick={handleClick} />
                        )
                    })}
                </div>
            }
        </span>
    );
}

export default CategoryBreadcrumb;